import React from 'react';
import Container from '../../components/Container';
import { SerializedError } from '../../store/reducers/articles';

const ErrorPage: React.FC<SerializedError> = ({ message }) => {
    return (
        <Container>
            <h4>{message}</h4>
        </Container>
    )
}

export default ErrorPage;